import { useNavigate } from 'react-router-dom';
import { ConfirmationModalType } from 'services/modals/constants';
import { useConfirmationModal } from 'services/modals/hooks';
import { Paths } from 'services/navigation/paths';

export const useCancelCampaign = ({ campaignId }: { campaignId: string }) => {
  const { showModal } = useConfirmationModal();
  const navigate = useNavigate();

  const handleCancelCampaign = () => {
    navigate(`${Paths.OUTBOUND_CAMPAIGN}/${campaignId}`);
  };

  const showCancelCampaignModal = () => {
    showModal({
      title: 'Cancel this campaign?',
      message: 'You will lose all your settings. This cannot be undone',
      onDestructiveConfirm: handleCancelCampaign,
      modalType: ConfirmationModalType.DESTRUCTIVE,
      cancelText: 'Back'
    });
  };

  return {
    showCancelCampaignModal
  };
};
